/* eslint-disable sonarjs/no-duplicate-string */
define([
    'jQuery',
    'toolkit/b-layer/b-layer',
    'toolkit/b-panel/b-panel',
    'toolkit/b-checkbox/b-checkbox',
], ($, BLayer /* , BPanel*/) => {
    return BLayer.extend('confirm-dialog', {
        inner: true,
        renderMode: 'replace',
        canHide: true,

        init() {
            this.templateBlock = 'b-layer';

            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.init.apply(this, arguments);

            this._confirmed = !this.data.confirmator;
        },

        onClose() {
            this.emit('cancel');
        },

        onBeforeApprove() {
            if (this._confirmed) {
                this.emit('approve');
            } else {
                this._error.toggleMod('visible', true);
            }
        },

        onRender() {
            if (this.data.confirmator) {
                this._error = this.$('.js-error');
                this._confirmator = this.$('.js-confirmator').getBlock();

                this._confirmator.on('change', (e, checked) => {
                    this._confirmed = checked;

                    if (checked) {
                        this._error.toggleMod('visible', false);
                    }
                });
            }
        },

        getData() {
            // eslint-disable-next-line prefer-rest-params
            let data = BLayer.fn.getData.apply(this, arguments);

            data = $.extend(
                {},
                {
                    block: 'b-panel',
                    mods: ['confirm-dialog'],
                    params: {
                        mods: ['popup', 'service'],

                        header: {
                            title: data.header || 'Подтвердите действие',
                        },
                        close: true,
                        view: 'confirm-dialog',
                        content: {
                            mods: [],
                            message:
                                data.message !== false
                                    ? data.message || 'Подумайте еще раз!'
                                    : undefined,
                            error: data.error || 'Требуется установка чекбокса',
                            confirmator: data.confirmator,
                        },
                        footer: {
                            btn: [
                                {
                                    mods: ['main'],
                                    name: 'before-approve',
                                    text: data.ok || 'Подтвердить',
                                },
                                {
                                    name: 'cancel',
                                    text: data.cancel || 'Отменить',
                                },
                            ],
                        },
                    },
                },
            );

            return data;
        },
    });
});
